import axios from 'axios'
import Utils from '../../../common/utils';

export default {
  getReportSpecialists: function (parameters) {
    return axios.get('/api/analytics/specialists/report', {params: parameters});
  },
  exportReportSpecialists: function(parameters) {
    return Utils.downloadFile('/api/analytics/specialists/exportreport', "ReportSpecialists.xlsx", parameters);
  },
  getSpecialistsReportFields: function() {
    return axios.get('/api/analytics/specialists/fields');
  },

  getReportOrgCapacity: function (parameters) {
    return axios.get('/api/analytics/orgcapacity/report', {params: parameters});
  },
  exportReportOrgCapacity: function(parameters) {
    return Utils.downloadFile('/api/analytics/orgcapacity/exportreport', "ReportOrgCapacity.xlsx", parameters);
  },
  getOrgCapacityReportFields: function() {
    return axios.get('/api/analytics/orgcapacity/fields');
  }
}